export default __webpack_public_path__ + "static/media/ChartIcon.79c86742.svg";